"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubConnaissancesMarcheImmobilierTrads = void 0;
exports.ESubConnaissancesMarcheImmobilierTrads = {
    aucune: "Aucune",
    faible: "Faible",
    moyenne: "Moyenne",
    eleve: "Elevé",
    expert: "Expert",
};
